import Whylawtransition from "./sections/Whylawtransition";
import EarlyLessonNarrative from "./sections/EarlyLessonNarrative";
import PracticeEvolution from "./sections/Practiceevolution";
import { Link } from "@/components/common/Link";
export default function OurStoryPage() {
  return <main className="bg-background text-foreground">
      <Whylawtransition />

      <EarlyLessonNarrative />

      <section id="what-experience-means" className="relative overflow-hidden bg-background py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-20">
            <div className="lg:col-span-5">
              <p className="mb-5 text-xs font-medium uppercase tracking-[0.28em] text-muted-foreground">
                What Experience Means
              </p>

              <h2 className="max-w-xl font-serif text-4xl font-medium leading-[1.08] tracking-[-0.02em] text-primary md:text-5xl lg:text-[3.5rem]">
                Knowing What to Examine
              </h2>

              <div aria-hidden="true" className="mt-7 h-px w-16 bg-secondary" />
            </div>

            <div className="lg:col-span-7">
              <div className="max-w-3xl space-y-6 text-lg leading-8 text-foreground/80">
                <p>
                  Experience is not the assumption that every answer is already
                  known. It is the ability to recognize which facts matter,
                  which documents require closer review, what questions remain
                  unanswered, and where further investigation may change the
                  analysis.
                </p>

                <p>
                  Morrie I. Levine approaches each matter by evaluating the
                  available information, identifying the legal and practical
                  issues, and determining what additional research or
                  clarification may be required.
                </p>
              </div>

              <blockquote className="my-10 border-l-2 border-secondary pl-7 md:my-12 md:pl-9">
                <p className="font-serif text-3xl italic leading-[1.3] tracking-[-0.01em] text-primary md:text-4xl">
                  “I do not claim to know every answer immediately.”
                </p>
              </blockquote>

              <div className="max-w-3xl space-y-6 text-lg leading-8 text-foreground/80">
                <p>
                  When an issue requires further analysis, his approach is to
                  investigate, research, and work to find the answer rather
                  than rely on an automatic conclusion.
                </p>

                <p>
                  Experience also does not mean assuming that the conventional
                  approach is always the correct one. When the facts justify
                  it, a different legal theory or an unconventional approach
                  may deserve careful consideration.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PracticeEvolution />

    <section id="south-florida" className="relative overflow-hidden bg-background py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mb-14 max-w-4xl lg:mb-20">
            <p className="mb-5 text-xs   font-medium uppercase tracking-[0.28em] text-muted-foreground">
              Rooted in South Florida
            </p>

            <h2 className="font-serif text-4xl font-medium leading-[1.08] tracking-[-0.02em] text-primary md:text-5xl lg:text-[3.5rem]">
              Hollywood and the Community
            </h2>

            <div aria-hidden="true" className="mt-7 h-px w-16 bg-secondary" />
          </div>

          <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-20">
            <div className="lg:col-span-5">
              <div className="space-y-6 text-lg leading-8 text-foreground/80">
                <p>
                  The office is based in Hollywood, Florida, and serves clients
                  throughout South Florida.
                </p>

                <p>
                  Decades of work in the region have provided practical
                  familiarity with its business environment, real estate
                  market, court systems, and the legal issues that arise for
                  business owners, property owners, fiduciaries, beneficiaries,
                  and families.
                </p>

                <p>
                  The firm’s continued presence in Hollywood provides local
                  context for the matters it reviews while remaining connected
                  to the broader South Florida community.
                </p>
              </div>
            </div>

            <div className="lg:col-span-7">
  <figure className="relative aspect-[4/3] overflow-hidden rounded-sm border border-border/60 bg-muted/20">
    <img src="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/MIL-with-his-sponsored-traffic-sign.jpg" alt="Morrie I. Levine standing beside his sponsored traffic sign in Hollywood, Florida" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" style={{
                objectPosition: "50% 52%"
              }} />
  </figure>
</div>
          </div>
        </div>
      </section>

      <section id="practice-today" className="relative overflow-hidden border-y border-border/50 bg-muted/20 py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-20">
            <div className="lg:col-span-5">
              <p className="mb-5 text-xs font-medium uppercase tracking-[0.28em] text-muted-foreground">
                The Practice Today
              </p>

              <h2 className="max-w-xl font-serif text-4xl font-medium leading-[1.08] tracking-[-0.02em] text-primary md:text-5xl lg:text-[3.5rem]">
                A Practice Built Around Attorney Judgment
              </h2>

              <div aria-hidden="true" className="mt-7 h-px w-16 bg-secondary" />
            </div>

            <div className="lg:col-span-7">
              <div className="max-w-3xl space-y-6 text-lg leading-8 text-foreground/80">
                <p>
                  The standards of the practice have been shaped by more than
                  four decades of legal experience: begin with the facts,
                  review the relevant documents in context, identify the
                  unanswered questions, and provide a realistic assessment of
                  the available course.
                </p>

                <p>
                  Organization and preparation support the legal work, but they
                  do not replace attorney judgment. The significance of a
                  document, the risks of a proposed action, and the strategy
                  appropriate to a matter depend on its individual facts,
                  applicable law, procedural requirements, and practical
                  circumstances.
                </p>

                <p>
                  This approach allows the office to work methodically while
                  preserving what matters most: careful attention, clear
                  communication, thorough investigation, and legal judgment
                  applied to the individual matter.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="our-story-next-step" className="relative overflow-hidden bg-primary py-24 text-primary-foreground lg:py-32">
        <div className="mx-auto max-w-5xl px-6 text-center lg:px-8">
          <p className="mb-5 text-xs font-medium uppercase tracking-[0.28em] text-primary-foreground/65">
            The Next Step
          </p>

          <h2 className="mx-auto max-w-4xl font-serif text-4xl font-medium leading-[1.08] tracking-[-0.02em] md:text-5xl lg:text-[3.5rem]">
            Begin by Clarifying the Matter
          </h2>

          <div aria-hidden="true" className="mx-auto mt-7 h-px w-16 bg-secondary" />

          <div className="mx-auto mt-10 max-w-2xl space-y-5 text-lg leading-8 text-primary-foreground/80">
            <p>
              People often contact a lawyer before they know exactly how to
              define the problem.
            </p>

            <p>
              The initial conversation begins by identifying the matter, the
              people involved, the available documents, any applicable
              deadlines, and what the client is trying to accomplish.
            </p>
          </div>

          <div className="mt-10">
            <Link href="/ContactUsPage" className="inline-flex min-h-[52px] items-center justify-center rounded-sm bg-secondary px-9 py-3.5 text-sm font-semibold text-secondary-foreground transition-opacity duration-200 hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 focus-visible:ring-offset-primary">
              Request a Consultation
            </Link>
          </div>

          <p className="mx-auto mt-8 max-w-2xl text-sm leading-6 text-primary-foreground/60">
            Contacting the office does not create an attorney-client
            relationship. Please do not send confidential information until the
            firm confirms acceptance of the matter.
          </p>
        </div>
      </section>
    </main>;
}